<template>
  
  <el-form label-width="120px" label-position="left" hide-required-asterisk @submit.native.prevent :model="form" ref="form">
    <el-form-item label="网站口号" prop="slogan">
      <zt-input max-width="340px" v-model="form.slogan" disabled/>
      <p class="help">显示在网站左上角的一段文字，1至20个字符，1个中文计为1个字符</p>
    </el-form-item>

    <el-form-item label="推广QQ群" prop="jq_qq_code">
      <zt-input max-width="340px" v-model.trim="form.jq_qq_code"/>
      <p class="help">群号将在所有用户个人中心显示</p>
    </el-form-item>

    <el-form-item label="网站公告" prop="ad">
      <zt-input max-width="340px" type="textarea" rows="4" v-model="form.ad"/>
      <p class="help">显示在网站首页的一段公告文字，1至100个字符，1个中文计为1个字符</p>
    </el-form-item>

    <el-form-item label="自定义页脚" prop="footer">
      <zt-input max-width="340px" type="textarea" rows="4" v-model="form.footer" disabled/>
      <p class="help">用来显示公安备案信息等html代码，显示在页底部，代码长度不超过500个字符</p>
    </el-form-item>

    <el-form-item label="统计代码" prop="tj_code">
      <zt-input max-width="340px" type="textarea" rows="4" v-model="form.tj_code"/>
      <p class="help">仅支持cnzz统计，请输入cnzz统计代码里的id。<!-- <a href="#">如何获取id?</a> --></p>
    </el-form-item>
    <el-form-item label="公众号id" prop="wxgzh">
      <zt-input max-width="340px" v-model.trim="form.wxgzh"/>
      <p class="help">显示在个人中心的联系客服页</p>
    </el-form-item>

    <el-form-item label="公众号二维码">
        <qrcode-upload ref="upload"  :src="form.wxgzh_qrurl" @changeFace="changeImg"></qrcode-upload>      
    </el-form-item>

    <zt-button type="primary" @click.enter.exact="onVerify" min-width="140px">保存</zt-button>
  </el-form>
</template>

<script>

import infoMixin from '../mixins/info'
import qrcodeUpload from '@cps/Upload/qrcodeUpload'
export default {
  name: 'CMSWebSiteConfigMore',
  mixins: [ infoMixin ],
  components:{qrcodeUpload},
  data: () => ({
    form: {
      wxgzh_qrurl:'',
      wxgzh:'',
      slogan: '', // 口号
      jq_qq_code: '', // 加群代码
      ad: '', // 网站公告
      footer: '', // 自定义页脚
      tj_code: '',  // 统计代码

      // 接口必传参数
      title: '',  // 网站标题
      domain: '', // 网站域名
      logo: '', // logo
      qq: '',
      wx: '', // 微信客服
      icpno: '',  // 备案信息
      cms_pid: '',  // cms pid
      tkl_pid: '',  // 淘口令 pid
      ssl: '',  // HTTPS域名
      cms_tksy: 0,
      cms_member_allow_agent_apply: 1,
      cms_member_allow_agent_auto_join: 0,
      assign_order_by_trade_last6code: 1, //1为开启自动跟单
      // share_domain: '', // 分享域名
    },
  }),
  methods: {
    changeImg(filePath) {
      this.form.wxgzh_qrurl = filePath
    },
    onVerify() {
      let reg_qq_code = /^\d{1,12}$/

      if(this.form.jq_qq_code) {
        if(!reg_qq_code.exec(this.form.jq_qq_code)) {
          this.$message.error('请输入12位以内纯数字QQ群号')
          return
        }
      }

      this.onSubmit()
    },
  },
}
</script>

<style lang="scss" scoped>
// @import "~@/styles/form.scss";

.help a {
  color: $theme;
}
</style>